


  import {defineComponent} from 'vue';
  import * as _ from 'lodash';

  import ToTop from '@/components/shared/TopButtonComponent.vue';
  import Navigator from '@/components/shared/NavigatorComponent.vue';
  import SubNavigator from '@/components/shared/SubNavigator.vue';
  import SortOptionComponent from '@/components/productList/SortOptionComponent.vue';
  import TicketListItem from '@/components/ticketList/TicketListItem.vue';

  import Ticket from "@/domain/ticket/Ticket";
  import {SortOption} from "@/domain/sort/SortOption";
  import api from "@/api/backend-api";
  import PageableRequest from "@/domain/request/PageableRequest";
  import NoTicketComponent from "@/components/ticketList/NoTicketComponent.vue";
  import router from "@/router";
  import {NamedRouting} from "@/domain/utils/NamedRouting";
  import {mapGetters, mapMutations, mapState} from "vuex";
  import HeaderComponent from "@/components/shared/HeaderComponent.vue";
  import store from "@/store";

  export default defineComponent({
    name: 'MyTicket',
    components: {
      HeaderComponent,
      Navigator,
      SubNavigator,
      SortOptionComponent,
      TicketListItem,
      NoTicketComponent,
      ToTop
    },
    data() {
      return {
        page : 1 as number,
        perPage: 20 as number,
        hasMorePage: true as boolean,

        isLoading: false as boolean,
        isFirstLoading: true as boolean,

        debouncedScrollEvent: () => {return},

        tickets: [] as Array<Ticket>,
        totalCount: 0 as number,
      }
    },
    created() {
      this.initSortOption(new Array<SortOption> (
          new SortOption("BY_LATEST", "최신순", true),
          new SortOption("BY_REMAINED_DAYS", "기한 임박순", false)
      ));
    },
    mounted() {
      this.loadNewTicket();
      this.debouncedScrollEvent = _.debounce(this.infiniteScrollEvent, 100);
      window.addEventListener('scroll', this.debouncedScrollEvent);
    },
    beforeUnmount(): void {
      window.removeEventListener('scroll', this.debouncedScrollEvent);
    },
    methods: {
      infiniteScrollEvent(): void {
        const targetElement = document.getElementById("app");
        if (targetElement === undefined) {
          return;
        }

        const heightOfElement: number = targetElement!.scrollHeight;
        const topOfElement: number = window.scrollY;
        const clientHeightOfElement: number = targetElement!.clientHeight;
        const bottomOffset = 100;

        if (heightOfElement <= topOfElement + clientHeightOfElement + bottomOffset) {
          this.loadMoreTicket();
        }
      },
      loadNewTicket(): void {
        if (this.isLoading) {
          return;
        }
        this.isFirstLoading = true;
        this.isLoading = true;

        this.page = 1;
        this.hasMorePage = true;
        const sortBy = this.getSortOptionValue;
        const request = new PageableRequest(this.page, this.perPage, sortBy);

        api.getUsableTicketList(request)
        .then(response => {
          if (response.data.code === 4444) {
            if (store.getters['AppYnStore/isApp']) {
              router.push(new NamedRouting('NonMemberViewForApp', {channelId: store.state.ChannelStore.channelId}));
            } else {
              store.commit('NextViewStore/setNextView', new NamedRouting('MyUsableTicketView'));
              router.push(new NamedRouting('NonMemberView', store.state.ChannelStore.channelId));
            }
            return;
          }

          this.totalCount = response.data.result.totalCount;
          this.tickets = response.data.result.ticketList.map(ticket => new Ticket(ticket));

          if (response.data.result.ticketList.length < this.perPage) {
            this.hasMorePage = false;
          }
        })
        .catch(error => {
          console.log("Error: " + error);
        })
        .finally(() => {
          this.isLoading = false;
          this.isFirstLoading = false;
        });
      },
      loadMoreTicket(): void {
        if (!this.hasMorePage || this.isLoading) {
          return;
        }
        this.isLoading = true;

        this.page += 1;
        const sortBy = this.getSortOptionValue;
        const request = new PageableRequest(this.page, this.perPage, sortBy);

        api.getUsableTicketList(request)
        .then(response => {
          if (response.data.code === 4444) {
            if (store.getters['AppYnStore/isApp']) {
              router.push(new NamedRouting('NonMemberViewForApp', {channelId: store.state.ChannelStore.channelId}));
            } else {
              store.commit('NextViewStore/setNextView', new NamedRouting('MyUsableTicketView'));
              router.push(new NamedRouting('NonMemberView', store.state.ChannelStore.channelId));
            }
            return;
          }

          response.data.result.ticketList.forEach(ticket => {
            this.tickets.push(new Ticket(ticket));
          });

          if (response.data.result.ticketList.length < this.perPage) {
            this.hasMorePage = false;
          }
        })
        .catch(error => {
          console.log("Error: " + error);
        })
        .finally(() => {
          this.isLoading = false;
        });
      },
      moveToDetailPage(ticketId: number): void {
        router.push(new NamedRouting('TicketDetailView', {ticketId: ticketId}));
      },
      ...mapMutations('SortOptionStore', [
        'initSortOption',
      ]),
    },
    computed: {
      isEmpty(): boolean {
        return this.totalCount === 0;
      },
      ...mapGetters('SortOptionStore', [
        'getSortOptionValue'
      ]),
      ...mapGetters('AppYnStore', [
        'isApp'
      ]),
    }
  })

